<template>
  <section class="section bg-footer text-white">
    <div class="container mx-auto w-full p-10 border-top">
      <div class="row flex justify-between w-full">
        <div class="lg:w-[50%] w-full underline-offset-1 lg:mb-0 mb-3">
          <h2 class="text-2xl font-semibold pb-3">INFORMATION</h2>
          <div class="flex flex-col gap-2">
            <div class="flex items-center gap-2 text-left">
              <p class="text-blue-200">
                BAC HA SOFTWARE DEVELOPMENT AND INVESTMENT COMPANY LIMITED
              </p>
            </div>
            <div class="flex items-center gap-2">
              <img
                src="@/assets/introduction/ic_baseline-phone.b9d60648.svg"
                alt=""
                srcset=""
              />
              <p>0372500284</p>
            </div>
            <div class="flex items-center gap-2">
              <img
                src="@/assets/introduction/Vector.7dcc3138.svg"
                alt=""
                srcset=""
              />
              <p>contact@meloha.com</p>
            </div>
            <div
              class="flex items-center gap-2 xl:w-[600px] lg:w-[460px] md:w-[400px] text-left"
            >
              <img
                src="@/assets/introduction/mdi_address-marker-outline.88b99884.svg"
                alt=""
                srcset=""
              />
              <p>
                Room 20, Floor 35, C5 D'Capitale Building, 119 Tran Duy Hung,
                Trung Hoa Ward, Cau Giay District, Hanoi
              </p>
            </div>
          </div>
        </div>
        <div class="lg:w-[50%] w-full flex justify-between">
          <div class="grid-cols-6 underline-offset-1">
            <h2 class="text-2xl font-semibold text-left pb-3">POLICY</h2>
            <div class="flex flex-col gap-4">
              <div
                class="flex items-center gap-2 border-b pt-2 pb-2 cursor-pointer"
              >
                <img
                  src="@/assets/introduction/icon-park-outline_right.dce5d52f.svg"
                  alt=""
                  srcset=""
                />
                <p>Terms of Service</p>
              </div>
              <div class="flex items-center gap-2 pt-2 pb-2 cursor-pointer">
                <img
                  src="@/assets/introduction/icon-park-outline_right.dce5d52f.svg"
                  alt=""
                  srcset=""
                />
                <p>Privacy Policy</p>
              </div>
            </div>
          </div>
          <div class="grid-cols-3 underline-offset-1">
            <h2 class="text-2xl font-semibold text-left pb-3">SERVICES</h2>
            <div class="flex flex-col gap-4">
              <div class="flex items-center gap-2 pt-2 pb-2 cursor-pointer">
                <img
                  src="@/assets/introduction/icon-park-outline_right.dce5d52f.svg"
                  alt=""
                  srcset=""
                />
                <p>Abouts</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section bg-footer text-white">
    <div class="container mx-auto w-full p-10 border-top">
      <div class="row">
        <div class="grid-cols-10 underline-offset-1 w-full">
          <div class="w-full flex justify-between text-describe pt-2 pb-2">
            <div>FAQ / Terms of Service / Privacy Policy</div>
            <div>© Copyright 2024. Designed by Bac Ha Company</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "footer-page",

  data() {
    return {};
  },

  methods: {},
});
</script>

<style lang="scss" scoped>
.text-describe {
  color: #979798;
  font-size: 16px;
}

.border-top {
  border-top: 1px solid #bdbacd30;
}
</style>
